/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Elementos',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Atualizado',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'Novo',
  'company-hub.hub-element-placeholder.extension.sub-heading': 'Ainda não há nada aqui. Pense nas possibilidades...',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'Visualizar todas as opções',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'Espaço reservado para elementos do hub',
};
